var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 204,
    viewBox: "0 0 250 204",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.62 203.59c94.34 0 145.94-78.16 145.94-145.94 0-2.22 0-4.43-.15-6.63A104.36 104.36 0 00250 24.47a102.38 102.38 0 01-29.46 8.07 51.47 51.47 0 0022.55-28.37 102.79 102.79 0 01-32.57 12.45C194.62-.286 169.357-4.424 148.895 6.527c-20.461 10.95-31.032 34.266-25.785 56.873A145.62 145.62 0 0117.4 9.81C3.786 33.246 10.74 63.229 33.28 78.28A50.91 50.91 0 0110 71.86v.65c.007 24.416 17.218 45.445 41.15 50.28a51.21 51.21 0 01-23.16.88c6.72 20.894 25.976 35.208 47.92 35.62a102.92 102.92 0 01-63.7 22A104.41 104.41 0 010 180.55a145.21 145.21 0 0078.62 23",
    fillRule: "evenodd"
  })));
}
export default SvgTwitterinline;